import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import ownerAgrementServices from "../../services/owner-services/owner-agreement";
import { handleErrors } from "../../utils/errorHandler";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FaFileAlt, FaFileSignature } from "react-icons/fa"; // Place this at the top of your file
import { Tooltip } from "primereact/tooltip";
import { useParams } from "react-router-dom"; // ✅ to read propertyGuid from URL

const OwnerAgreementTable = () => {
  const [agreementList, setAgreementList] = useState([]);
  const { propertyGuid } = useParams();
  useEffect(() => {
    async function fetchAgreementData() {
      try {
        const response = await ownerAgrementServices.getAgreementInfo(
          propertyGuid
        );
        setAgreementList(response.data.result || []);
      } catch (error) {
        toast.error(handleErrors(error));
      }
    }

    if (propertyGuid) {
      fetchAgreementData();
    }
  }, [propertyGuid]);
  const propertyNameWithFlatNo = (rowData) => {
    return (
      <div>
        <b> Property Name : </b>
        {rowData.propertyName},
        <br />
        <b> Flat No : </b> {rowData.flatNos}
      </div>
    );
  };

  const renderUnsignedDocButton = (rowData) => {
    if (!rowData.unsignedDocLink) return "-";

    return (
      <>
        <Tooltip
          target=".unsigned-doc-icon"
          content="View Unsigned Doc"
          className="custom-tooltip"
        />
        <span
          onClick={() => window.open(rowData.unsignedDocLink, "_blank")}
          className="unsigned-doc-icon fs-3 me-2"
          style={{ cursor: "pointer" }}
        >
          <FaFileAlt />
        </span>
      </>
    );
  };

  const renderSignedDocButton = (rowData) => {
    if (!rowData.signedDocLink) return "-";

    return (
      <>
        <Tooltip
          className="custom-tooltip"
          target=".signed-doc-icon"
          content="View Signed Doc"
        />
        <span
          onClick={() => window.open(rowData.signedDocLink, "_blank")}
          className="signed-doc-icon  fs-3"
          style={{ cursor: "pointer" }}
        >
          <FaFileSignature />
        </span>
      </>
    );
  };
  const formatDated = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(dateString)
      .toLocaleDateString("en-GB", options)
      .replace(/ /g, "-");
  };
  const renderStatusBadge = (rowData) => {
    const status = rowData.status?.toLowerCase();

    let badgeColor = "secondary";
    let label = rowData.status || "Unknown";

    if (status === "created") {
      badgeColor = "warning";
    } else if (status === "sent") {
      badgeColor = "info";
    } else if (status === "signed") {
      badgeColor = "success";
    }

    return (
      <span className={`badge bg-${badgeColor} text-uppercase`}>{label}</span>
    );
  };

  return (
    <div className="agreement-list">
      <h3>Agreements Details</h3>
      <Row>
        <Col xs={12}>
          <DataTable
            value={agreementList}
            paginator
            rows={10}
            showGridlines
            stripedRows
          >
            <Column header="#" body={(rowData, { rowIndex }) => rowIndex + 1} />
            <Column field={propertyNameWithFlatNo} header="Property Name" />
            <Column field={renderUnsignedDocButton} header="Draft Doc" />
            <Column field={renderSignedDocButton} header="Signed Doc" />
            <Column field={renderStatusBadge} header="Status" />
            <Column
              body={(rowData) => formatDated(rowData.createdOn)}
              header="Created On"
            />
            <Column
              body={(rowData) =>
                rowData.signedDocLink ? formatDated(rowData.signedOn) : "-"
              }
              header="Signed On"
            />
          </DataTable>
        </Col>
      </Row>
    </div>
  );
};

export default OwnerAgreementTable;
